import React, { Component } from "react";
import { Outlet } from "react-router-dom";

export default class TransferForm extends Component {
  render() {
    return (
      <>
        <Outlet />
      </>
    );
  }
}
